import React from "react";
import studioData from "../data/studioData.json";

const Studio = () => {
  const aboutParagraphs = Array.isArray(studioData.studioOverview) ? studioData.studioOverview : [];
  const [leadParagraph, ...supportingParagraphs] = aboutParagraphs;
  const founder = studioData.founder ?? null;
  const founderBio = Array.isArray(founder?.bio) ? founder.bio : founder?.bio ? [founder.bio] : [];

  return (
    <section id="studio" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12 md:py-16">
      <div className="glass-panel p-8 md:p-12">
        <p className="section-kicker">01 About</p>

        <div className="mt-7 grid items-start gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
          {leadParagraph && (
            <p className="text-2xl leading-tight tracking-[-0.01em] text-white md:text-3xl">
              {leadParagraph}
            </p>
          )}

          <div className="space-y-5">
            {supportingParagraphs.map((paragraph, index) => (
              <p key={index} className="border-l border-white/15 pl-4 text-base leading-relaxed text-text-secondary md:text-lg">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {founder && founderBio.length > 0 && (
          <div className="mt-10 border-t border-white/10 pt-8 md:mt-12 md:pt-10">
            <div className="grid items-start gap-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
              <div>
                <p className="section-kicker">{founder.kicker ?? "Founder"}</p>
                {founder.name && (
                  <p className="mt-3 text-xl font-medium tracking-[-0.01em] text-white md:text-2xl">
                    {founder.name}
                  </p>
                )}
                {founder.role && (
                  <p className="mt-2 text-sm leading-relaxed text-text-secondary md:text-base">{founder.role}</p>
                )}
                {founder.registration && (
                  <p className="mt-1 text-sm tracking-[0.02em] text-text-secondary md:text-base">
                    {founder.registration}
                  </p>
                )}
              </div>

              <div className="space-y-5">
                {founderBio.map((paragraph, index) => (
                  <p key={index} className="border-l border-white/15 pl-4 text-base leading-relaxed text-text-secondary md:text-lg">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Studio;
